var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{ 'loading': _vm.working }})
}
var staticRenderFns = []

export { render, staticRenderFns }